export function getDateOrNull(value: string | undefined | null) {
  return value === null || value === undefined ? null : new Date(value);
}
